import React, { useEffect, useState } from "react";
import { Navbar, Nav, NavDropdown, NavItem, Container} from 'react-bootstrap';
import { Link,NavLink } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {   faRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import placmentLogo from '../../assets/placementlogow.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {   faUser } from '@fortawesome/free-solid-svg-icons'

export default function CandidateNavbar() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [registerNumber, setRegisterNumber] = useState('');
  const [sticky, setSticky] = useState(false);

  const [values, setValues] = useState([{
    V_companyname: "",
    V_jobfair: "",
    id: "",
    name: {
      first_name: null,
      email: null,
      phone: null,
    }
  }])
 
  useEffect(() => {
      const volunteer = localStorage.getItem("user");
    
    const user = localStorage.getItem("user");
    if (user !== null) {
      setName(JSON.parse(user)[0].name__first_name);
      setRegisterNumber(JSON.parse(user)[0].register_num);
    }
    else {
      localStorage.removeItem("user");
      navigate('/Volunteer_login');
      return;
    }
    const Id = JSON.parse(volunteer)[0].id;
    axios.get(`https://pl.aspireitacademy.com/volunteer_Details/${Id}`).then((response) => {
      setValues(response.data);
      // console.log(response.data)
      console.log(values[0].name["first_name"])



    })

  }, [])

  const handleClick = () => {
    localStorage.removeItem("user");
    navigate('/Volunteer_login' );
  }

  const handleScroll = () => {
    if (window.scrollY >= 100) {
      setSticky(true)
    }
    else {
      setSticky(false)
    }
  };
  window.addEventListener("scroll", handleScroll);
// className={sticky ? "fixed-top" : ""}
  return (
    <>
      <Navbar   sticky="top" variant="dark" expand="sm" style={{ backgroundColor: '#309197',boxShadow: "0 2px 6px rgba(0,0,0,0.05)"}}>
        <Container>
          <Navbar.Brand>
            <NavLink to="/Searchjob_seeker">
            <img src={placmentLogo} alt="logo" width="160px" height="45px" />
            </NavLink>
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse  >
          <Nav className="ms-4 me-auto" id="nav" >
              <NavLink    to="/Searchjob_seeker"  className="nav-link me-2" >Jobseeker</NavLink>
              <NavLink    to="/Report_generation" className="nav-link me-2" >Reports</NavLink>
            </Nav>
            <Nav>
            <Navbar.Text  className="d-none d-md-block" >[ Volunteer ]</Navbar.Text>
              <NavDropdown title={values[0].name["first_name"]} >
               
                <NavDropdown.Item   className="p-2" id="nav-drop"
                 onClick={()=> navigate('/Edit_Profile' ) }
                >
                <FontAwesomeIcon icon={faUser} /> <span >Profile</span>
               
                {/* <Link to="/Edit_Profile" style={{textDecoration:'none',color:'#000'}} >
                <FontAwesomeIcon icon={faUser} /> <span >Profile</span></Link> */}
                </NavDropdown.Item>
               
               
                <NavDropdown.Item className="p-2" id="nav-drop"
                 onClick={handleClick}
                >
                <FontAwesomeIcon icon={faRightFromBracket} />  <span>Logout</span>

                  {/* <Link to="/Volunteer_login"  style={{ color:'#000',textDecoration: "none" }}
                  onClick={handleClick}  
                 >
                  <FontAwesomeIcon icon={faRightFromBracket} />  <span>Logout</span></Link> */}
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  )
}
